module.exports = "/images/south_ossetia.svg?b888f1e30a7a8b2426ea2664e533018c";